module.exports = __webpack_public_path__ + "img/PC11.43566d50.png";